<template>
    <b-modal
        v-model="isShown"
        centered
        :title="title"
        lazy
    >
        <Spinner v-if="loading" />
        <b-container
            v-else
            fluid
        >
            <b-row>
                <b-form-group class="w-100">
                    <div><label>Pricing Mode</label></div>
                    <b-form-radio-group
                        v-model="selectedPricingMode"
                        name="radioSubComponent"
                    >
                        <b-form-radio value="1">
                            Total price + flat fee
                        </b-form-radio>
                        <b-form-radio value="2">
                            Total price + percentage
                        </b-form-radio>
                        <b-form-radio value="3">
                            Fixed price
                        </b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group class="w-100">
                    <div><label>Fee Amount</label></div>
                    <b-form-input
                        v-model.trim="$v.feeAmount.$model"
                        type="text"
                    />
                    <b-form-invalid-feedback :force-show="!$v.feeAmount.required">
                        The fee amount is required.
                    </b-form-invalid-feedback>
                    <b-form-invalid-feedback :force-show="!$v.feeAmount.decimal">
                        The fee amount must be a decimal value.
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-row>

            <b-row v-if="this.defaultFeeTaxRate">
                <b-form-group class="w-100">
                    <b-form-checkbox
                        v-model="enableTaxRate"
                        class="mt-2"
                    >
                        Enable fee tax
                    </b-form-checkbox>
                </b-form-group>
            </b-row>

            <b-row v-if="enableTaxRate && !quote">
                <div><label>Fee Tax Rate</label></div>
                <b-form-group class="w-100">
                    <TaxRateSelect
                        v-model="feeTaxRateId"
                        :disabled="true"
                    />
                </b-form-group>
            </b-row>
        </b-container>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="isShown = false"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :disabled="loading || $v.$anyError"
                :loading="submitLoading"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import { required, decimal } from 'vuelidate/lib/validators';
import TaxRateSelect from '@/components/TaxRateSelect.vue';

export default {
    components: { TaxRateSelect },

    data() {
        return {
            title: '',
            quote: false,
            isShown: false,
            loading: false,
            submitLoading: false,
            selectedPricingMode: '',
            feeAmount: '0.0000',
            onSubmit: null,
            feeTaxEnabled: false,
            feeTaxRateId: '',
            defaultFeeTaxRate: null,
        };
    },

    validations: {
        feeAmount: {
            required,
            decimal,
        },
    },
    computed: {
        enableTaxRate: {
            get() {
                return this.feeTaxEnabled;
            },
            set(val) {
                this.feeTaxEnabled = val;

                if (val) {
                    this.feeTaxRateId = this.defaultFeeTaxRate;
                } else {
                    this.feeTaxRateId = '';
                }
            },
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openEditPricingModeModal, async (e) => {
            this.loading = true;
            this.title = e.title;
            this.isShown = true;
            this.onSubmit = e.onSubmit;
            const data = await e.onOpen();
            this.selectedPricingMode = data.pricing_mode;
            this.feeAmount = data.fee_amount;
            this.feeTaxEnabled = (data.fee_tax_rate_id !== null);
            this.feeTaxRateId = data.fee_tax_rate_id;
            this.defaultFeeTaxRate = data.default_fee_tax_rate;
            this.loading = false;
            this.quote = e.quote;
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            await this.onSubmit({
                pricingMode: this.selectedPricingMode,
                feeAmount: this.feeAmount,
                feeTaxRateId: (this.feeTaxEnabled && !this.quote) ? this.feeTaxRateId.id : null,
            });
            this.submitLoading = false;
            this.isShown = false;
        },
    },

};
</script>
